module.exports = __webpack_public_path__ + "img/cases-1.ff474b15.png";